
const OpenDataComponent = () => {

    const handleClick = () => {
        // Open URL in a new tab
        window.open('/open_data', '_blank');
        
        // Optionally, navigate internally as well
        // navigate('/some_internal_route');
    };
    return(
        <section id="open_data">
            <div className="container">
                <div className="row content">
                    <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                        <img src={`${process.env.PUBLIC_URL}/template/img/features.svg`} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-8 pt-5 order-2 order-md-1" data-aos="fade-up">
                        <h2 className="flex-content"><i className="bx bxs-data mr-1"></i><b> Open Data</b></h2>
                        <br/>
                        <h3>Temukan Data yang Anda cari</h3>
                        <p className="font-size-medium font-weight-100">
                            Open Data menyediakan akses pada publik untuk mencari, melihat, dan mengunduh data secara terbuka.
                        </p>
                        <br/><br/>
                        <a href='#' onClick={handleClick} className="download-btn">
                            Buka Open Data
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OpenDataComponent;